import Logo from "./Component/Logo";
import Login from "./Component/Login";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import ResetPassword from "./Component/ResetPassword";
import UploadPassport from "./Component/UploadPassport";
import PassportDetails from "./Component/PassportDetails";
import Dashbord from "./Component/Dashboard";
import SessionTimer from "./Component/SessionTimer";
import { useEffect, useState } from "react";
import BottomNavigationBar from "./Component/BottomNavigation";
import NotArrangeHotel from "./Component/NotArrange/NotArrangeHotel";
import CheckInHotelMakkah from "./Component/ActualHotel/CheckInHotelMakkah";
import CheckInHotelMadina from "./Component/ActualHotel/CheckInHotelMadina";
import AllowHotelMakkah from "./Component/AllowHotel/AllowHotelMakkah";
import AllowHotelMadina from "./Component/AllowHotel/AllowHotelMadina";
import MAKKAHTPT from "./Component/TransportTPT/MAKKAHTPT";
import MADINATPT from "./Component/TransportTPT/MADINATPT";
import JEDDAHTPT from "./Component/TransportTPT/JEDDAHTPT";
import ArrivalDeparture from "./Component/TransportTPT/ArrivalDeparture";
import SingleAllowTransport from "./Component/SingleAllowTransport";
import RouteChecker from "./Component/reuseableComponents/RouteChecker";
import ActualMakkahTpt from "./Component/ActualTransport/ActualMakkahTpt";
import ActualmedinaTpt from "./Component/actualmedinaTpt/ActualmedinaTpt";
import ActualjaddahTpt from "./Component/actualjaddahTpt/ActualjaddahTpt";

function App(props) {
  const [showDrawer, setShowDrawer] = useState(false);
  useEffect(() => {}, []);

  function StripTrailingSlash() {
    const { pathname, search } = useLocation();

    // if not root and ends with slash, redirect to same path without slash
    if (pathname !== "/" && pathname.endsWith("/")) {
      const newPath = pathname.replace(/\/+$/, "");
      return <Navigate to={newPath + search} replace />;
    }
    return null;
  }





  
  return (
    <div className="App">
      <StripTrailingSlash />
      <Routes>
        <Route path="/" element={<Logo />} />

        {/*-------------------------- remaoveable ------------------------------------------- */}

        {/* <Route  path="/drawer"element={<Drawer setShowDrawer={setShowDrawer} />} /> */}
        {/* ----------------------------end--------------------------------------------------- */}

        <Route path="/login" element={<Login apiHost={props.apiHost} />} />
        <Route path="/dashboard" element={<Dashbord />} />

        <Route path="/not-arrange" element={<NotArrangeHotel />} />
        <Route
          path="/allow-hotel-makkah"
          element={
            <RouteChecker>
              <AllowHotelMakkah />
            </RouteChecker>
          }
        />
        <Route
          path="/allow-hotel-madina"
          element={
            <RouteChecker>
              <AllowHotelMadina />
            </RouteChecker>
          }
        />
        <Route
          path="/checkin-makkah-hotel"
          element={
            <RouteChecker>
              <CheckInHotelMakkah />
            </RouteChecker>
          }
        />
        <Route
          path="/checkin-madina-hotel"
          element={
            <RouteChecker>
              <CheckInHotelMadina />
            </RouteChecker>
          }
        />
        <Route
          path="/reset-password"
          element={<ResetPassword apiHost={props.apiHost} />}
        />
        <Route
          path="/upload-passport"
          element={
            <RouteChecker>
              <UploadPassport />
            </RouteChecker>
          }
        />
        <Route
          path="/passport-details"
          element={
            <RouteChecker>
              <PassportDetails />
            </RouteChecker>
          }
        />
        <Route
          path="/allow-makkah-tpt"
          element={
            <RouteChecker>
              <MAKKAHTPT />
            </RouteChecker>
          }
        />
        {/* These are for single allow entires  */}
        <Route
          path="/single-allow-activity"
          element={
            <RouteChecker>
              <SingleAllowTransport />
            </RouteChecker>
          }
        />
      

        <Route
          path="/allow-madina-tpt"
          element={
            <RouteChecker>
              <MADINATPT />
            </RouteChecker>
          }
        />

        <Route
          path="/allow-jeddah-tpt"
          element={
            <RouteChecker>
              <JEDDAHTPT />
            </RouteChecker>
          }
        />

        <Route
          path="/arrival-departure-tpt"
          element={
            <RouteChecker>
              <ArrivalDeparture />
            </RouteChecker>
          }
        />

        {/* for actual transport  */}

        <Route
          path="/actual-makkah-tpt"
          element={
            <RouteChecker>
              <ActualMakkahTpt />
            </RouteChecker>
          }
        />

        <Route
          path="/actual-madina-tpt"
          element={
            <RouteChecker>
              <ActualmedinaTpt />
            </RouteChecker>
          }
        />

        <Route
          path="/actual-jeddah-tpt"
          element={
            <RouteChecker>
              <ActualjaddahTpt />
            </RouteChecker>
          }
        />

        {/* transport  */}
        {/* <Route path="/actual-tpt-form" element={<ActualMAkkahTPTForm />} /> */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      {/* ------------------------------------------------------------------------------- */}

      <SessionTimer expirationDuration={13000000} />
      {window.location.pathname !== "/login" &&
        window.location.pathname !== "/" && (
          <BottomNavigationBar
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
          />
        )}
    </div>
  );
}

export default App;
